import * as React from "react";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";

export default function LinerLoader() {
  return (
    // <Box sx={{ width: "100%" }}>
    <div style={{ width: "100%" }}>
      <LinearProgress />
    </div>
    // </Box>
  );
}
